import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=0aad533e&scoped=true"
import script from "./Hall.vue?vue&type=script&lang=js"
export * from "./Hall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad533e",
  null
  
)

export default component.exports